import { Link } from 'react-router-dom';
import { FiUsers, FiBarChart2 } from 'react-icons/fi';

export default function LandingPage() {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.brand}>
          <h1 style={styles.title}>NEOM Hospital</h1>
          <p style={styles.subtitle}>Academic & Training Affairs Hub</p>
        </div>

        <div style={styles.cards}>
          <Link to="/team/login" style={styles.card}>
            <div style={styles.iconWrap}>
              <FiUsers size={32} color="#6B8063" />
            </div>
            <h2 style={styles.cardTitle}>Team Portal</h2>
            <p style={styles.cardDesc}>
              Manage life support courses, staff certifications, and grand
              rounds activities.
            </p>
            <span style={styles.cardLink}>Sign in &rarr;</span>
          </Link>

          <Link to="/dio/login" style={styles.card}>
            <div style={styles.iconWrap}>
              <FiBarChart2 size={32} color="#6B8063" />
            </div>
            <h2 style={styles.cardTitle}>Director Portal</h2>
            <p style={styles.cardDesc}>
              View dashboards, generate reports, and oversee department
              performance.
            </p>
            <span style={styles.cardLink}>Sign in &rarr;</span>
          </Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#F5F0E8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
  },
  container: {
    textAlign: 'center',
    maxWidth: '720px',
    width: '100%',
  },
  brand: {
    marginBottom: '48px',
  },
  title: {
    fontSize: '2.2rem',
    fontWeight: 700,
    color: '#2B362E',
    margin: 0,
  },
  subtitle: {
    fontSize: '1.05rem',
    color: '#6b6b6b',
    marginTop: '8px',
  },
  cards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px',
  },
  card: {
    background: '#ffffff',
    borderRadius: '16px',
    padding: '36px 28px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.06)',
    textDecoration: 'none',
    color: '#2B362E',
    transition: 'transform 0.2s, box-shadow 0.2s',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  iconWrap: {
    width: '64px',
    height: '64px',
    borderRadius: '16px',
    backgroundColor: 'rgba(107, 128, 99, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
  },
  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: 600,
    margin: '0 0 8px',
  },
  cardDesc: {
    fontSize: '0.9rem',
    color: '#6b6b6b',
    lineHeight: 1.5,
    margin: '0 0 16px',
  },
  cardLink: {
    fontSize: '0.9rem',
    fontWeight: 600,
    color: '#6B8063',
  },
};
